module.exports = __webpack_public_path__ + "search-4539e462/Background_01_4x3_a-891f1dfdc89a5b163898a11cfa1a6450.svg";